export const AvatarNavbarVehiclesIcon = ({
  className = '',
}: {
  className?: string
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1460_91951)">
        <path
          d="M12.75 13.54H6.83"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M2.75 13.54H1.04V8.54L4.37 4.38H12.71L15.21 8.54H19.37V13.54H16.83"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M4.79 16.04C5.94 16.04 6.88 15.11 6.88 13.96C6.88 12.81 5.94 11.88 4.79 11.88C3.64 11.88 2.71 12.81 2.71 13.96C2.71 15.11 3.64 16.04 4.79 16.04Z"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M14.79 16.04C15.94 16.04 16.88 15.11 16.88 13.96C16.88 12.81 15.94 11.88 14.79 11.88C13.64 11.88 12.71 12.81 12.71 13.96C12.71 15.11 13.64 16.04 14.79 16.04Z"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M15.21 8.54H1.04"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M8.54 4.38V8.54"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_1460_91951">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
